export enum ImageSize {
  Original = 'ORIGINAL',
  Mini = 'MINI',
  Thumbnail = 'THUMB',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  App = 'APP',
}
